t = require('views/internal/teacup-with-helpers')('org_create')
ClientConfig = require 'debug/client-config'

module.exports = ->
  t.form ->

    t.p '.error', { style: 'display:none' }

    t.label { for: 'org-display-name' }, ->
      t.format 'name'
    t.input '.js-autofocus.js-display-name', { type: 'text', name: 'displayName', id: 'org-display-name', value: t.mustacheVar('displayName'), dir: 'auto', maxLength: 100 }

    t.label { for: 'org-desc' }, ->
      t.format 'description-optional'
    t.textarea { id: 'org-desc', name: 'desc', dir: 'auto' }, ->
      t.text t.mustacheVar('desc')

    if t.mustacheVar('boardToAddToOrg') && t.mustacheVar('memberCount') > 1
      t.div '.check-div', ->
        t.input '.js-add-members', { type: 'checkbox', checked: true, id: 'addMembers' }
        t.label { for: 'addMembers', class: 'create-team-add-members' }, ->
          t.format 'add-the-members-of-this-board-to-the-team'

    t.input '.primary.wide.js-save', { type: 'submit', value: t.l('create') }

  t.hr()

  t.p '.quiet', ->
    t.format 'a-team-is-a-group-of-boards-and-people'

  if !ClientConfig.get('dontUpsell')
    t.p '.quiet.u-bottom', ->
      t.format 'business-class-gives-your-organization-more'
      t.text ' '
      t.a '.js-business-class', { href: '/business-class', target: '_blank' }, ->
        t.format 'learn-more'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/org_create.coffee